import { ReactNode } from 'react';

type ColorVariant =
  | 'default'
  | 'red'
  | 'blue'
  | 'green'
  | 'purple'
  | 'amber'
  | 'gray';

interface StatCardProps {
  value: ReactNode;
  label: string;
  color?: ColorVariant;
  className?: string;
}

const colorStyles: Record<ColorVariant, string> = {
  default: 'text-gray-900 dark:text-gray-100',
  red: 'text-red-600 dark:text-red-400',
  blue: 'text-blue-600 dark:text-blue-400',
  green: 'text-green-600 dark:text-green-400',
  purple: 'text-purple-600 dark:text-purple-400',
  amber: 'text-amber-600 dark:text-amber-400',
  gray: 'text-gray-600 dark:text-gray-400',
};

export default function StatCard({
  value,
  label,
  color = 'default',
  className = '',
}: StatCardProps) {
  return (
    <div
      className={`p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 ${className}`}
    >
      <div className={`text-2xl font-bold ${colorStyles[color]}`}>{value}</div>
      <div className="text-sm text-gray-500 dark:text-gray-400">{label}</div>
    </div>
  );
}
